<div class="form-container">
  <div class="header-section">
    <div class="description">
      <h2 class="title">Create Geofence</h2>
      <p class="subtitle">Draw geofence on Map</p>
    </div>

    <div class="close">
      <button
        class="p-button-plain p-button-icon-only no-bg"
        pButton
        type="button"
        icon="pi pi-times"
        variant="text"
        (click)="closeDialog(null)"
      ></button>
    </div>
  </div>

  <div class="geofence-form-page">
    <div class="form-container">
      <form class="geofence-form" (ngSubmit)="onSubmit()">
        <div class="form-field-container">
          <div class="form-field">
            <label class="field-label" for="name">
              Name
              <span class="required">*</span>
            </label>

            <input
              class="field-input"
              id="name"
              type="text"
              pInputText
              placeholder="Enter geofence name"
              [formField]="geofenceForm.name"
              [class.error]="geofenceForm.name().touched() && geofenceForm.name().invalid()"
            />
            @if (geofenceForm.name().touched() && geofenceForm.name().errors().length) {
              <div class="error-message">
                @for (error of geofenceForm.name().errors(); track error.message) {
                  <p-message severity="error">{{ error.message }}</p-message>
                }
              </div>
            }
          </div>
        </div>

        <div class="map-help">
          <small>
            Use the Draw tool in the map toolbar to draw your geofence area with at least 3 points. Click the polygon
            to select it, then drag its points to adjust the shape. Drag a midpoint to add a new point, or right-click
            a point to remove it.
          </small>
        </div>

        <app-google-maps-polygon-editor
          [enableDrawing]="true"
          [initialDrawingMode]="true"
          [geofences]="[slimGeofence()]"
          [restrictToHubBounds]="false"
          (geofenceCoordinatesChange)="onGeofenceCoordinatesChange($event)"
        ></app-google-maps-polygon-editor>

        @if (geofenceForm.coordinates().value().length) {
          @let coordsValid = geofenceForm.coordinates().valid();
          <div class="polygon-status">
            <p-message [severity]="coordsValid ? 'success' : 'warn'">
              {{ coordsValid ? 'Valid polygon created' : 'Invalid polygon - need at least 3 points' }}
            </p-message>
          </div>
        }

        <div class="form-actions">
          <p-button label="Cancel" [text]="true" (onClick)="onCancel()"></p-button>
          <p-button label="Create" [disabled]="loading() || geofenceForm().invalid()" (onClick)="onSubmit()"></p-button>
        </div>
      </form>
    </div>
  </div>
</div>
